import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxState from '../../cx/CxState';
import CxChooser from '../../cx/CxChooser';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import { getStoreValue, setStoreValue, isApp } from "../../gx/GxStore";
import GxForm from '../../gx/GxForm';


const MxSettSlsGeneral = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const r_snack_save = React.useRef(null);

  let r_form = React.useRef(null);

  const rf_itSeriesDef = React.useRef(null);
  const rf_boDecimalsInDocs = React.useRef(null);
  const rf_boAnnualNumeration = React.useRef(null);
  const rf_boAutoCreateFq = React.useRef(null); //crea repl o vacc
  const rf_boAutoCreateComm = React.useRef(null); //crea comunicación
  const rf_boSpecialInvoice = React.useRef(null);
  const rf_boSpecialReceipt = React.useRef(null);
  const rf_boShowClientA4 = React.useRef(null); //muestra datos del cliente en la impresión
  const rf_boShowClientA5 = React.useRef(null); //muestra datos del cliente en la impresión
  const rf_boShowClientA8 = React.useRef(null); //muestra datos del cliente en la impresión
  const rf_boDDebitReqAccInfo = React.useRef(null); //si al pagar con domiciliación se exigen datos de la cuenta bancaria
  const rf_boDefaultIsReceipt = React.useRef(null);
  const rf_boElectronicPurse = React.useRef(null);
  const rf_boDontRemLastSeries = React.useRef(null);
  const rf_boAutoCreateRxForce = React.useRef(null); //fuerza creación de receta. 
  const rf_boAutoCreateMp = React.useRef(null); //creación de doc con múltiples pacientes 
  const rf_boUseInvoices = React.useRef(null); 
  const rf_boUseReceipts = React.useRef(null); 
  /* NO APLICAN A VWEB.
  const rf_boAutoCreateRx = React.useRef(null); 
  const rf_boFirstTabIsClient = React.useRef(null); 
  const rf_boConfirmationEnabled = React.useRef(null); 
  */

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    Promise.all([FxFetch.doJsonX('sett/app/r', record)]).then((result) => {
      if (result[0]) {
        FxLog.infox('MxSettSlsGeneral.formLoad', '...result[0][0]:', result[0][0]);
        rf_itSeriesDef.current?.setKeyAndVal2(result[0][0].itSeriesDef);
        rf_boDecimalsInDocs.current?.setVal(result[0][0].boDecimalsInDocs);
        rf_boAnnualNumeration.current?.setVal(result[0][0].boAnnualNumeration);
        if (isApp('opti') || isApp('vett')) rf_boAutoCreateFq.current?.setVal(result[0][0].boAutoCreateFq);
        rf_boAutoCreateComm.current?.setVal(result[0][0].boAutoCreateComm);
        if (isApp('vett')) rf_boAutoCreateRxForce.current?.setVal(result[0][0].boAutoCreateRxForce);
        if ((isApp('opti') || isApp('vett') || isApp('spaw'))) rf_boSpecialInvoice.current?.setVal(result[0][0].boSpecialInvoice);
        if ((isApp('vett') || isApp('spaw'))) rf_boSpecialReceipt.current?.setVal(result[0][0].boSpecialReceipt);
        rf_boShowClientA4.current?.setVal(result[0][0].boShowClientA4);
        rf_boShowClientA5.current?.setVal(result[0][0].boShowClientA5);
        rf_boShowClientA8.current?.setVal(result[0][0].boShowClientA8);
        rf_boDDebitReqAccInfo.current?.setVal(result[0][0].boDDebitReqAccInfo);
        rf_boDefaultIsReceipt.current?.setVal(result[0][0].boDefaultIsReceipt);
        rf_boElectronicPurse.current?.setVal(result[0][0].boElectronicPurse);
        rf_boDontRemLastSeries.current?.setVal(result[0][0].boDontRemLastSeries);
        rf_boUseInvoices.current?.setVal(result[0][0].boUseInvoices);
        rf_boUseReceipts.current?.setVal(result[0][0].boUseReceipts);
        if (isApp('vett')) rf_boAutoCreateMp.current?.setVal(result[0][0].boAutoCreateMp);
      }
    });
  }

  const formSaveCustom = async () => {
    let filter = { "inBranch": getStoreValue('StoreSession', 'inBranch'), };
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    

    record['itSeriesDef'] = rf_itSeriesDef.current?.getKey();
    record['boDecimalsInDocs'] = rf_boDecimalsInDocs.current?.getVal();
    record['boAnnualNumeration'] = rf_boAnnualNumeration.current?.getVal();
    if (isApp('opti') || isApp('vett')) record['boAutoCreateFq'] = rf_boAutoCreateFq.current?.getVal();
    record['boAutoCreateComm'] = rf_boAutoCreateComm.current?.getVal();
    if (isApp('vett')) record['boAutoCreateRxForce'] = rf_boAutoCreateRxForce.current?.getVal();
    if ((isApp('opti') || isApp('vett') || isApp('spaw'))) record['boSpecialInvoice'] = rf_boSpecialInvoice.current?.getVal();
    if ((isApp('vett') || isApp('spaw'))) record['boSpecialReceipt'] = rf_boSpecialReceipt.current?.getVal();
    record['boShowClientA4'] = rf_boShowClientA4.current?.getVal();
    record['boShowClientA5'] = rf_boShowClientA5.current?.getVal();
    record['boShowClientA8'] = rf_boShowClientA8.current?.getVal();
    record['boDDebitReqAccInfo'] = rf_boDDebitReqAccInfo.current?.getVal();
    record['boDefaultIsReceipt'] = rf_boDefaultIsReceipt.current?.getVal();
    record['boElectronicPurse'] = rf_boElectronicPurse.current?.getVal();
    record['boDontRemLastSeries'] = rf_boDontRemLastSeries.current?.getVal();
    record['boUseInvoices'] = rf_boUseInvoices.current?.getVal();
    record['boUseReceipts'] = rf_boUseReceipts.current?.getVal();
    if (isApp('vett')) record['boAutoCreateMp'] = rf_boAutoCreateMp.current?.getVal();
    
    setStoreValue('StoreSession', 'itSeriesDef', rf_itSeriesDef.current?.getKey());
    setStoreValue('StoreSession', 'boDecimalsInDocs', rf_boDecimalsInDocs.current?.getVal());
    setStoreValue('StoreSession', 'boAnnualNumeration', rf_boAnnualNumeration.current?.getVal());
    if (isApp('opti') || isApp('vett')) setStoreValue('StoreSession', 'boAutoCreateFq', rf_boAutoCreateFq.current?.getVal());
    setStoreValue('StoreSession', 'boAutoCreateComm', rf_boAutoCreateComm.current?.getVal());
    if (isApp('vett')) setStoreValue('StoreSession', 'boAutoCreateRxForce', rf_boAutoCreateRxForce.current?.getVal());
    if ((isApp('opti') || isApp('vett') || isApp('spaw'))) setStoreValue('StoreSession', 'boSpecialInvoice', rf_boSpecialInvoice.current?.getVal());
    if ((isApp('vett') || isApp('spaw'))) setStoreValue('StoreSession', 'boSpecialReceipt', rf_boSpecialReceipt.current?.getVal());
    setStoreValue('StoreSession', 'boShowClientA4', rf_boShowClientA4.current?.getVal());
    setStoreValue('StoreSession', 'boShowClientA5', rf_boShowClientA5.current?.getVal());
    setStoreValue('StoreSession', 'boShowClientA8', rf_boShowClientA8.current?.getVal());
    setStoreValue('StoreSession', 'boDDebitReqAccInfo', rf_boDDebitReqAccInfo.current?.getVal());
    setStoreValue('StoreSession', 'boDefaultIsReceipt', rf_boDefaultIsReceipt.current?.getVal());
    setStoreValue('StoreSession', 'boElectronicPurse', rf_boElectronicPurse.current?.getVal());
    setStoreValue('StoreSession', 'boDontRemLastSeries', rf_boDontRemLastSeries.current?.getVal());
    setStoreValue('StoreSession', 'boUseInvoices', rf_boUseInvoices.current?.getVal());
    setStoreValue('StoreSession', 'boUseReceipts', rf_boUseReceipts.current?.getVal());
    if (isApp('vett')) setStoreValue('StoreSession', 'boAutoCreateMp', rf_boAutoCreateMp.current?.getVal());


    Promise.all([FxFetch.doJsonF("sett/app/u", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current?.setOpen(true);
        }
      }
    });

    r_snack_save.current?.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.sales')} - ${trans('field.general')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >

        <CxChooser xref={rf_itSeriesDef} label={trans('field.default_x_0', 'field.series')}
          dbfield="itSeriesDef"
          table="t_series"
          col_id="itSeries"
          col_tx="txTypeSeries"
          extra_filter_1={"boActive='1'"}
        />
        <CxState mode='checkbox' xref={rf_boDontRemLastSeries} dbfield="boDontRemLastSeries" label={trans('field.sett_dont_rem_last_series')} />

        <CxState mode='checkbox' xref={rf_boDecimalsInDocs} dbfield="boDecimalsInDocs" label={trans('field.sett_decimals_in_docs')} />
        <CxState mode='checkbox' xref={rf_boAnnualNumeration} dbfield="boAnnualNumeration" label={trans('field.sett_annual_numeration')} />
        <CxState mode='checkbox' xref={rf_boShowClientA4} dbfield="boShowClientA4" label={trans('field.sett_show_client') + " A4"} />
        <CxState mode='checkbox' xref={rf_boShowClientA5} dbfield="boShowClientA5" label={trans('field.sett_show_client') + " A5"} />
        <CxState mode='checkbox' xref={rf_boShowClientA8} dbfield="boShowClientA8" label={trans('field.sett_show_client') + " A8"} />
        <CxState mode='checkbox' xref={rf_boDDebitReqAccInfo} dbfield="boDDebitReqAccInfo" label={trans('field.sett_ddebit_req_acc_info')} />
        <CxState mode='checkbox' xref={rf_boDefaultIsReceipt} dbfield="boDefaultIsReceipt" label={trans('field.sett_default_receipt')} />
        <CxState mode='checkbox' xref={rf_boElectronicPurse} dbfield="boElectronicPurse" label={trans('field.sett_electronic_purse')} />
        <CxState mode='checkbox' xref={rf_boUseInvoices} dbfield="boUseInvoices" label={trans('field.sett_use_x', 'field.invoices')} />
        <CxState mode='checkbox' xref={rf_boUseReceipts} dbfield="boUseReceipts" label={trans('field.sett_use_x', 'field.receipts')} />

        {isApp('vett') && <CxState mode='checkbox' xref={rf_boAutoCreateMp} dbfield="boAutoCreateMp" label={trans('field.sett_auto_create_mp')} />}
        {isApp('opti') && <CxState mode='checkbox' xref={rf_boAutoCreateFq} dbfield="boAutoCreateFq" label={trans('field.sett_auto_create_fq_repl')} />}
        {isApp('vett') && <CxState mode='checkbox' xref={rf_boAutoCreateFq} dbfield="boAutoCreateFq" label={trans('field.sett_auto_create_fq_vacc')} />}
        {(isApp('opti') || isApp('vett')) && <CxState mode='checkbox' xref={rf_boAutoCreateComm} dbfield="boAutoCreateComm" label={trans('field.sett_auto_create_comm')}
          tooltip={trans("field.required") + ": " + (isApp('opti') ? trans("field.sett_auto_create_fq_repl") : trans("field.sett_auto_create_fq_vacc"))}
          tooltipType="alert"
          />}

        {isApp('vett') && <CxState mode='checkbox' xref={rf_boAutoCreateRxForce} dbfield="boAutoCreateRxForce" label={trans('field.sett_auto_create_rx_force')} />}
        {(isApp('opti') || isApp('vett') || isApp('spaw')) && <CxState mode='checkbox' xref={rf_boSpecialInvoice} dbfield="boSpecialInvoice" label={trans('field.sett_spec_x','field.invoices')} />}
        {(isApp('vett') || isApp('spaw')) && <CxState mode='checkbox' xref={rf_boSpecialReceipt} dbfield="boSpecialReceipt" label={trans('field.sett_spec_x','field.receipts')} />}

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
    </div>
  );

}

export default MxSettSlsGeneral;
